export const LOYALTY_INFO = "loyaltyInfo";
export const LOYALTY_INFO_MUTATION = "loyaltyInfoMutation";

export default {
    namespace: "loyaltyModule",

    state: {
        seasonInfo: {},
    },

    actions: {
        [LOYALTY_INFO]({ commit }, payload) {
            commit(LOYALTY_INFO_MUTATION, payload);
        },
    },

    mutations: {
        [LOYALTY_INFO_MUTATION](state, payload) {
            state.seasonInfo = payload;
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/loyaltyModule.js